module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"normoltTips":["CPU：8核/16核（推荐 E5 2650v2）","内存：32GB/64GB","数据盘：2TB /4TB /8TB SSD （推荐 Nvme）","系统盘：100GB SSD （安装 CentOS 7.6 系统）"],"mergeTips":["CPU：16核（推荐 E5 2650v2 *2）","内存：64GB","数据盘：4TB /8TB SSD （推荐 Nvme）","系统盘：100GB SSD （安装 CentOS 7.6 系统）"]}}')
  delete Component.options._Ctor
}
